import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IconButton, Stack, Grid, Chip, FormGroup, FormControlLabel, Checkbox, Typography, Box } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { setSuspect, setUsed, setClean, cleanSuspect, cleanUsed, cleanClean, getSuspect, getUsed, getClean } from '../../features/qrCodeFilters';

function QrCodeFilters() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [searchParams, setSearchParams] = useSearchParams();
  const filters = searchParams.has('suspect') || searchParams.has('used') || searchParams.has('clean');

  const toBoolean = (value) => {
    if (typeof value === 'string') {
      return value.toLowerCase() === 'true';
    }
    return Boolean(value);
  };

  const suspect = toBoolean(useSelector(getSuspect));
  const used = toBoolean(useSelector(getUsed));
  const clean = toBoolean(useSelector(getClean));

  useEffect(() => {
    if (searchParams?.get('suspect')) dispatch(setSuspect(searchParams?.get('suspect')));
    else dispatch(cleanSuspect());
    if (searchParams?.get('used')) dispatch(setUsed(searchParams?.get('used')));
    else dispatch(cleanUsed());
    if (searchParams?.get('clean')) dispatch(setClean(searchParams?.get('clean')));
    else dispatch(cleanClean());
  }, [searchParams]);

  const handleSuspectChange = (value) => {
    value ? searchParams.set('suspect', value) : searchParams.delete('suspect');
    setSearchParams(searchParams);
  };
  const handleSuspectReset = () => {
    dispatch(cleanSuspect());
    searchParams.delete('suspect');
    setSearchParams(searchParams);
  };

  const handleUsedChange = (value) => {
    value ? searchParams.set('used', value) : searchParams.delete('used');
    setSearchParams(searchParams);
  };
  const handleUsedReset = () => {
    dispatch(cleanUsed());
    searchParams.delete('used');
    setSearchParams(searchParams);
  };

  const handleCleanChange = (value) => {
    value ? searchParams.set('clean', value) : searchParams.delete('clean');
    setSearchParams(searchParams);
  };
  const handleCleanReset = () => {
    dispatch(cleanSuspect());
    searchParams.delete('clean');
    setSearchParams(searchParams);
  };

  const handleFiltersReset = () => {
    handleSuspectReset();
    handleUsedReset();
    handleCleanReset();
  };

  return (
    <>
      <Grid item>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
          <FormGroup>
            <FormControlLabel control={<Checkbox disabled={clean} checked={suspect} onChange={(e) => handleSuspectChange(e.target.checked)} />} label={t('organizations.product.lots.qrCode.suspect')} labelPlacement="top" />
          </FormGroup>
          <FormGroup>
            <FormControlLabel control={<Checkbox disabled={clean} checked={used} onChange={(e) => handleUsedChange(e.target.checked)} />} label={t('organizations.product.lots.qrCode.used')} labelPlacement="top" />
          </FormGroup>
          <FormGroup>
            <FormControlLabel control={<Checkbox disabled={used || suspect} checked={clean} onChange={(e) => handleCleanChange(e.target.checked)} />} label={t('organizations.product.lots.qrCode.clean')} labelPlacement="top" />
          </FormGroup>
        </Stack>
      </Grid>
      <Grid item xs={12} sx={{ justifyContent: 'left' }}>
        {filters && (
          <Box sx={{ display: 'flex', float: 'left', flexDirection: 'row', alignItems: 'center' }}>
            <Typography marginRight={2}>{t('organizations.product.lots.qrCode.filterBy')}:</Typography>
            <Stack direction="row" alignItems="center" spacing={2}>
              {searchParams?.get('suspect') && <Chip variant="filled" color="primary" label={t('organizations.product.lots.qrCode.suspect')} onDelete={handleSuspectReset} />}
              {searchParams?.get('used') && <Chip variant="filled" color="primary" label={t('organizations.product.lots.qrCode.used')} onDelete={handleUsedReset} />}
              {searchParams?.get('clean') && <Chip variant="filled" color="primary" label={t('organizations.product.lots.qrCode.clean')} onDelete={handleCleanReset} />}
            </Stack>
            <IconButton sx={{ marginLeft: 'auto' }} variant="contained" onClick={handleFiltersReset}>
              <DeleteIcon />
            </IconButton>
          </Box>
        )}
      </Grid>
    </>
  );
}

export default QrCodeFilters;
